export const BASE_URL = 'https://platform-api2.sacurn-dev.com';
